import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ActiveUserStorage {
  private localStorageKey = environment.apiBaseUrl + '-ActiveUserSession';

  constructor() { }

  getActiveUserSessionValue() {
    debugger
    let key = environment.apiBaseUrl + `-ActiveUserSession`;
    let value = localStorage.getItem(key)
    return JSON.parse(value)
  }

  getSharedData(): any {
    debugger
    const dataString = localStorage.getItem(this.localStorageKey);
    return dataString ? JSON.parse(dataString) : {};
  }

  setSharedData(data: any) {
    localStorage.setItem(this.localStorageKey, JSON.stringify(data));
  }

  setBulkDataWithExistingData(newData: any) {
    const existingData = this.getSharedData();
    const mergedData = { ...existingData, ...newData }; // Merge existing data with new data
    localStorage.setItem(this.localStorageKey, JSON.stringify(mergedData));
  }

  getValue(key: string): any {
    const data = this.getSharedData();
    return data[key];
  }

  /*this.ActiveUserStorage.setValue('address', this.placeDetails);
  this.ActiveUserStorage.setValue('areaProductMappingId', result.areaProductMappingId);
  this.ActiveUserStorage.setValue('onceOffFeeId', result.onceOffFeeId);
  this.ActiveUserStorage.setValue('productDetails', "");
  this.ActiveUserStorage.setValue('isONT', "");

  this.ActiveUserStorage.getValue('address')
  this.ActiveUserStorage.getValue('areaProductMappingId')
  this.ActiveUserStorage.getValue('onceOffFeeId')
  this.ActiveUserStorage.getValue('productDetails')
  this.ActiveUserStorage.getValue('isONT')
  */
  setValue(key: string, value: any) {
    const data = this.getSharedData();
    data[key] = value;
    this.setSharedData(data);
  }

  clearSharedData() {
    localStorage.removeItem(this.localStorageKey);
  }

  hasValue() {
    let address = this.getSharedData();

    if ((!address) || (address.addressLine1)) {
      return address != null;
    }
    else if (address.addressLine1) {
      return address.addressLine1 != null;
    }
    else {
      return false;
    }
  }
    removeParticularItem(key: string) {
    const data = this.getSharedData();
    if (data.hasOwnProperty(key)) {
      delete data[key];
      localStorage.removeItem(key);
    }
    this.setSharedData(data);
  }
}

/*

// Retrieve shared data when the component initializes
    this.sharedData = this.sharedDataService.getSharedData();

    // Update the shared data
    updateSharedData() {
    const newData = {
      key1: 'value1',
      key2: 'value2',
      // Add more key-value pairs as needed
    };
    this.sharedDataService.setSharedData(newData);
  }

  //set single value
  this.sharedDataService.setValue('isFirsttime', true);

  //get single value
  const isFirsttimeDDD = this.sharedDataService.getValue('isFirsttime');
*/
